import React, { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PixelsCard } from "./marketing/PixelsCard";
import { HubApiCard } from "./marketing/HubApiCard";
import { HubNativeCard } from "./marketing/HubNativeCard";
import { WebhookCard } from "./marketing/WebhookCard";
import { DeliveriesTable } from "./marketing/DeliveriesTable";
import { GoogleSheetCard } from "./marketing/GoogleSheetCard";

export default function MarketingIntegrations() {
  const [hub, setHub] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/hub");
      setHub(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo cargar la configuración del hub");
      setHub({ deliveries: [] });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="px-8 py-8 max-w-6xl" data-testid="marketing-page">
      <div className="mb-8">
        <div className="smallcaps">Administración</div>
        <h1 className="font-serif text-5xl leading-none mt-3">Marketing &amp; API</h1>
        <p className="text-sm text-clay-700 mt-3 max-w-2xl">
          Píxeles de publicidad para las landings públicas de Curated Trips y la conexión con tu landing hub:
          una API para leer los viajes publicados y un webhook que avisa cuando se publican, cambian o se llenan.
        </p>
      </div>
      <div className="space-y-6">
        <GoogleSheetCard/>
        <PixelsCard/>
        {hub ? (
          <>
            <HubNativeCard settings={hub} reload={load}/>
            <HubApiCard settings={hub} reload={load}/>
            <WebhookCard settings={hub} reload={load}/>
            <DeliveriesTable deliveries={hub.deliveries || []}/>
          </>
        ) : (
          <div className="flex items-center gap-2 text-sm text-clay-600"><Loader2 size={14} className="animate-spin"/> Cargando…</div>
        )}
      </div>
    </div>
  );
}
